/*
* Validate Error表示用の共通処理
*/
const $ = require('jquery')
const assets = require('../_require/assets')

module.exports = (function () {
  /*
    * チップス表示用の処理
    * hide をviewClassに渡すと上からスライドして表示される
    * showの場合アニメーションせずそのまま表示される
    */
  function headerTipsMessageRender (message, viewClass, hideTime, options) {
    let tmpl = '<div class="header-message-layer js-header-message-tips ' + viewClass + '"><div class="header-message-tips">'
    tmpl += '<svg class="icon-game"><use xlink:href="' + assets.setSvgPath('#icon-game') + '"></use></svg>'
    tmpl += message

    if (options && options.loadingTips) {
      tmpl += '<div class="colon-loading"><div class="colon1"></div><div class="colon2"></div><div class="colon3"></div></div>'
    }

    tmpl += '</div></div>'

    // 500エラーのtipsなど後からのtipsに消されたくない場合に js-strong-tipsを
    // クラスに設定することでtipsの割り込みを防ぐ
    if ($('.js-strong-tips').length > 0) {
      return
    }

    // すでに出ているtipsがあった場合はそれを閉じる
    $('.js-header-message-tips').remove()

    $('body').append(tmpl)

    if (viewClass.indexOf('hide') !== -1) {
      window.setTimeout(function () {
        $('.js-header-message-tips').removeClass('hide').addClass('show')
      }, 50)
    }

    // js-no-auto-hideが設定されていた場合は意図的に消されるまでtipsを消さない。
    if (viewClass.indexOf('js-no-auto-hide') !== -1) {
      return
    }

    if (!hideTime) {
      hideTime = 2000
    }
    window.setTimeout(function () {
      tipsHide()
    }, hideTime)
  }

  /*
    * チップスメッセージを非表示にする。
    * 上にスライドして消える
    */
  function tipsHide () {
    const $tips = $('.js-header-message-tips')
    $tips.addClass('hide')
    window.setTimeout(function () {
      $('.js-header-message-tips').remove()
    }, 1000)
  }

  /*
    * チップス表示をラップしたもの
    * 幅が100%の大きなメッセージを表示する。
    * 重要な操作の成功時や失敗時に表示する
    */
  function headerTipsMessageLongRender (message, viewClass, hideTime) {
    if (!hideTime) {
      hideTime = 2000
    }
    headerTipsMessageRender(message, viewClass + ' long', hideTime)
  }

  return {
    headerTipsMessageRender: headerTipsMessageRender,
    headerTipsMessageLongRender: headerTipsMessageLongRender,
    tipsHide: tipsHide
  }
})()
